export default [{
    path: '/dataDictionary',
    component: () => import('@/views/dataDictionary')
}, {
    path: '/dataDictionary/programmeTypeList',
    component: () => import('@/views/dataDictionary/programme-type-list')
}]